module.exports = __webpack_public_path__ + "img/logo.e985b8d1.png";